import {
  Sparkles,
  ShieldCheck,
  BadgeCheck,
  Scale,
  Lock,
  Flag,
} from "lucide-react";
import { useReveal } from "../../lib/animations";

const trustItems = [
  {
    icon: BadgeCheck,
    title: "Geen abonnement",
    desc: "Je betaalt enkel per analyse. Geen verborgen kosten.",
  },
  {
    icon: ShieldCheck,
    title: "GDPR-conform",
    desc: "Documenten worden 30 dagen bewaard en daarna automatisch verwijderd.",
  },
  {
    icon: Sparkles,
    title: "Slimme marktanalyse",
    desc: "Getraind op duizenden Belgische en Nederlandse marktprijzen.",
  },
  {
    icon: Scale,
    title: "Onafhankelijk",
    desc: "Geen banden met aannemers of leveranciers. Objectief advies.",
  },
  {
    icon: Lock,
    title: "Beveiligde uploads",
    desc: "Alle bestanden worden versleuteld opgeslagen.",
  },
  {
    icon: Flag,
    title: "Belgisch bedrijf",
    desc: "Gemaakt en beheerd door Webtron BV in Waregem, België.",
  },
];

export default function Trust() {
  const ref = useReveal();
  return (
    <section data-testid="trust-section" className="oc-section bg-white border-y border-oc-border">
      <div ref={ref} className="oc-reveal oc-container">
        <div className="max-w-5xl">
          <span className="inline-flex items-center gap-2 text-[13px] uppercase tracking-[0.1em] font-semibold text-oc-secondary">
            <span className="w-1.5 h-1.5 rounded-full bg-oc-fair" />
            Vertrouwen
          </span>
          <h2 className="font-display font-bold text-[28px] sm:text-[36px] lg:text-[42px] leading-tight tracking-tight text-oc-primary mt-3 whitespace-normal lg:whitespace-nowrap">
            Waarom mensen OfferteExpert vertrouwen
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-oc-border rounded-oc overflow-hidden">
          {trustItems.map((item, i) => {
            const Icon = item.icon;
            // alternate accent: every 2nd & 5th icon picks up the fair-green for subtle rhythm
            const useGreen = i === 1 || i === 4;
            return (
              <div
                key={i}
                className="bg-white p-9 hover:bg-oc-subtle transition-colors group"
                style={{ animation: `fade-in 500ms ease-out both ${i * 60}ms` }}
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center transition-colors ${useGreen ? "bg-oc-fair/10 text-oc-fair group-hover:bg-oc-fair group-hover:text-white" : "bg-oc-subtle text-oc-secondary group-hover:bg-oc-secondary group-hover:text-white"}`}>
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </div>
                <h3 className="font-display font-semibold text-[18px] text-oc-primary mt-5 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-oc-textSecondary text-[15px] leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
